import React from 'react';
import { Link } from 'react-router-dom';
import './404.css';

const NotFound = () => {
  return (
    <>
      <section>
        <h2 data-en="NOT FOUND">404 - Not Found</h2>
        <p>申し訳ありませんが、お探しのページは見つかりませんでした。</p>
        <Link to="/">ホームに戻る</Link>
      </section>
    </>
  );
};

export default NotFound;